import { useEffect, useState } from 'react';

import { trackingUuidManager } from '../utils/TrackingUuidManager';

/**
 * Hook that provides consistent user and session UUIDs for tracking purposes
 * Uses a singleton pattern to ensure UUIDs are unique and only created once
 * across multiple components
 */
export function useTrackingUuid() {
  // Use state to ensure consistent values within a component
  const [userUuid, setUserUuid] = useState(() => trackingUuidManager.getUserUuid());
  const [sessionUuid, setSessionUuid] = useState(() => trackingUuidManager.getSessionUuid());

  // Ensure the component always has the latest UUIDs from the manager
  useEffect(() => {
    const currentUserUuid = trackingUuidManager.getUserUuid();
    const currentSessionUuid = trackingUuidManager.getSessionUuid();

    if (userUuid !== currentUserUuid) {
      setUserUuid(currentUserUuid);
    }

    if (sessionUuid !== currentSessionUuid) {
      setSessionUuid(currentSessionUuid);
    }
  }, []);

  const resetSessionUuid = () => {
    const newSessionUuid = trackingUuidManager.resetSessionUuid();
    setSessionUuid(newSessionUuid);
    return newSessionUuid;
  };

  return {
    userUuid,
    sessionUuid,
    resetSessionUuid,
  };
}
